import {CircleAlert} from 'lucide-react';
import {useIntl} from 'react-intl';
import {PhoneHQSpinner} from 'ch3-ui-lib';
import {insightsMessages as m} from '../insightsMessages';
import {lucide} from '../insightsUi';
import {generationErrorMessage} from '../insightsErrors';

export interface GenerationState {
    pending: boolean;
    error: unknown;
}

export const GenerationStatus = ({generation, pendingLabel}: {generation: GenerationState; pendingLabel?: string}) => {
    const intl = useIntl();
    if (generation.pending) {
        return <PhoneHQSpinner size={18} label={pendingLabel ?? intl.formatMessage(m.summaryGenerating)}/>;
    }
    if (!generation.error) return null;
    return (
        <p role="alert" className="m-0 inline-flex items-start gap-1.5 text-footnote text-danger-ink">
            <CircleAlert size={14} aria-hidden="true" className={`${lucide} mt-px`}/>
            {generationErrorMessage(intl, generation.error)}
        </p>
    );
};
